module.exports = __webpack_public_path__ + "static/img/010.bf697bb6.png";